class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById('mini-cart').innerHTML = this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);


document.addEventListener("click", (e) => {
  const btn = e.target.closest("cart-remove-button a, .delete-product");
  if (!btn) return;

  e.preventDefault();

  // Find <li> of this product
  const itemRow = btn.closest("li");
  const overlay = itemRow ? itemRow.querySelector(".loading-overlay") : null;

  // Show overlay for this row only
  if (overlay) overlay.classList.remove("hidden");

  const miniCart = document.querySelector("mini-cart");
  const sections = miniCart ? miniCart.getSectionsToRender().map(s => s.section) : [];

  fetch(btn.getAttribute("href"))
    .then(() => fetch("/cart.js"))
    .then(res => res.json())
    .then(cart => {
      let removePromises = [];

      let gifts = cart.items.filter(i => i.properties && i.properties._freeGift === "true");

      gifts.forEach(gift => {
        let parentId = gift.properties._parentId;
        let parentExists = cart.items.find(i => i.variant_id == parentId);

        if (!parentExists) {
          removePromises.push(
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: gift.key,
                quantity: 0,
              }),
            }).then(res => res.json())
          );
        }
      });

      return Promise.all(removePromises);
    })
    .then(() => {
      if (miniCart) {
        fetch(`${window.location.pathname}?sections=${sections.join(",")}`)
          .then(res => res.json())
          .then(data => {
            miniCart.renderContents({ sections: data });
          });
      }
    })
    .catch(console.error)
    .finally(() => {
      if (overlay) overlay.classList.add("hidden");
    });
});


document.addEventListener("change", (e) => {
  const input = e.target.closest("quantity-input .quantity__input");
  if (!input) return;

  const newQty = parseInt(input.value, 10) || 0;

  const overlay = input.closest("li")?.querySelector(".loading-overlay");
  if (overlay) overlay.classList.remove("hidden");

  const lineIndex = input.dataset.index;

  // Update qty for changed product
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      line: lineIndex,
      quantity: newQty,
    }),
  })
    .then(() => fetch("/cart.js"))
    .then((res) => res.json())
    .then((cart) => {
      let removePromises = [];

      let gifts = cart.items.filter(
        (i) => i.properties && i.properties._freeGift === "true"
      );

      if (gifts.length) {
        const requiredProducts = window.selectedProductIds || [];

        // ✅ Check if at least 1 required product still in cart
        let atLeastOnePresent = requiredProducts.some((pid) =>
          cart.items.some((i) => i.product_id == pid && i.quantity > 0)
        );

        // ❌ Remove gift only if none of the required products remain
        if (!atLeastOnePresent) {
          gifts.forEach((gift) => {
            removePromises.push(
              fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  id: gift.key,
                  quantity: 0,
                }),
              }).then((res) => res.json())
            );
          });
        }
      }

      return Promise.all(removePromises);
    })
    .then(() => {
      const miniCart = document.querySelector("mini-cart");
      if (miniCart) {
        const sections = miniCart.getSectionsToRender().map((s) => s.section);
        return fetch(`${window.location.pathname}?sections=${sections.join(",")}`)
          .then((res) => res.json())
          .then((data) => {
            miniCart.renderContents({ sections: data });
          });
      }
    })
    .catch(console.error)
    .finally(() => {
      if (overlay) overlay.classList.add("hidden");
    });
});
